import * as cr from "./_cr";
//import * as cs from "./_ca";
//import * as hf from "./_hf";
import * as ht from "./_ht";

import { a } from "./_csAbt";

import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";
import * as SrlC from "./_ccbSrlC";

import { useMdlz } from "./_csMdl";

export const useMdlPcrz = () => {
  const _sMdlz = useMdlz();
//  const _abtType = 'nmlz';
//  const _abtz = cs.mdlIptAbtz[_abtType]();
  const _show = (pz: {
    ls?: ht.ls,
    onPrs: ( _dz: ht.dz ) => void,
  }) => {
    const _dw = cr.d('p') ? 60 : 40;
    const _ls = [
/*
      cr.c(BoxC.N, {
        key: -10,
        boxStlz: a(`br/1 dw/${_dw} dhx/80 fd/csc p/1 sc/lt1`),
        oClds:
          pz.ls?.map((_dz: ht.dz, _idx: ht.n) => (
            cr.c(BtnC.N, {
              key: _idx,
              boxStlz: a(`bc/lt5 bs/ds bwt/${_idx == 0 ? 0 : 0.5} fd/rcc dw/${_dw - 2} pv/1 ph/1`),
              pslPtyz: {
                onPress: () => {
                  if (pz.onPrs) pz.onPrs(_dz);
                  _sMdlz.set({
                    bShow: false,
                  });
                },
              },
              lblCz: {
                textz: {
                  pfx: _dz.pfx,
                  ptyz: a(`tn/1`),
                },
              },
            })
          ))
      })
*/
      cr.c(BoxC.N, {
        key: -10,
        boxStlz: a(`br/1 dw/${_dw} dhx/70 fd/csc p/1 sc/lt1`),
        oClds: [
          cr.c(SrlC.V, {
            key: -10,
            oClds:
              pz.ls?.map((_dz: ht.dz, _idx: ht.n) => (
                cr.c(BtnC.N, {
                  key: _idx,
                  boxStlz: a(`bc/lt5 bs/ds bwt/${_idx == 0 ? 0 : 0.5} fd/rcc dw/${_dw - 2} pv/1 ph/1`),
                  pslPtyz: {
                    onPress: () => {
                      if (pz.onPrs) pz.onPrs(_dz);
                      _sMdlz.set({
                        bShow: false,
                      });
                    },
                  },
                  lblCz: {
                    textz: {
                      pfx: _dz.pfx,
                      ptyz: a(`tn/1`),
                    },
                  },
                })
              ))
          })
        ]
          
      })
    ];
    //hf.l('ipt 44: here');
    _sMdlz.set({
      bShow: true,
      oClds: _ls
    })
  }
  return {
    show: _show
  }
};
